export default __webpack_public_path__ + "static/media/5-BFDC-Meeting-with-ICESTA-China.cdb84f80.jpg";